import React from 'react';
import { observer } from 'mobx-react-lite';
import { useGTagScript } from './hooks/useGTagScript';
/**
 * @module GTagProvider
 * @category Components
 * @subcategory Providers
 */

/**
 * @description
 * Initializes the global gtag script and provides the dataLayer and gtag object to other components
 * @todo
 * document this
 */
const GTagProvider = ({ children, measurementId }) => {
	useGTagScript(measurementId);
	return children;
};

GTagProvider.displayName = 'GTagProvider';
export default observer(GTagProvider);
